/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_TICKETS (state, tickets) {
    state.tickets = tickets
  },
  SET_FORMS (state, forms) {
    state.forms = forms
  },
  REMOVE_TICKET (state, itemId) {
    const trackIndex = state.tickets.findIndex((u) => u.TicketId === itemId)
    state.tickets.splice(trackIndex, 1)
  },
  REMOVE_FORM (state, itemId) {
    const trackIndex = state.forms.findIndex((u) => u.FormId === itemId)
    state.forms.splice(trackIndex, 1)
  }
}
